import { TimeWindowSection } from './time-window-section';
import { CartThresholdsSection } from './cart-thresholds-section';
import { ProductSelectionSection } from './product-selection-section';
import { CustomerRestrictionSection } from './customer-restriction-section';
import { SiteScopeSection } from './site-scope-section';

/** Tab 2 — Συνθήκες. */
export function ConditionsTab() {
	return (
		<div className="flex flex-col gap-4">
			<TimeWindowSection />
			<CartThresholdsSection />
			<ProductSelectionSection />
			<CustomerRestrictionSection />
			<SiteScopeSection />
		</div>
	);
}
